import { Abwesenheitsgrund } from '@/domain/mitarbeiter/shared/entities/Abwesenheitsgruende';
import { mapAbwesenheitsGrundToIcon } from '@/domain/mitarbeiter/shared/utils/mapAbwesenheitToIcon';
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import dayjs from 'dayjs';
import { t } from 'i18next';

export class Abwesenheit {
  constructor({
    id,
    von,
    bis,
    grund,
    faktor,
  }: {
    id: string;
    von: Date;
    bis: Date;
    grund: Abwesenheitsgrund;
    faktor: number;
  }) {
    this.id = id;
    this.von = von;
    this.bis = bis;
    this.grund = grund;
    this.faktor = faktor;
  }

  id: string;
  von: Date;
  bis: Date;
  grund: Abwesenheitsgrund;
  faktor: number;

  get abwesenheitsgrundIcon(): IconDefinition {
    return mapAbwesenheitsGrundToIcon(this.grund);
  }

  get zeitraumLabel(): string {
    const von = dayjs(this.von);
    const bis = dayjs(this.bis);

    if (von.isSame(bis, 'day') && this.faktor === 1) {
      return von.format('DD.MM.YYYY');
    }

    if (von.isSame(bis, 'day') && this.faktor !== 1) {
      return (
        von.format('DD.MM.YYYY') +
        ' ' +
        t(
          'domain.mitarbeiter.rotationsplan.rotationsplaene.abwesenheitPopover.halberTag',
        )
      );
    }

    if (von.isSame(bis, 'year')) {
      return von.format('DD.MM') + ' – ' + bis.format('DD.MM.YYYY');
    }

    return von.format('DD.MM.YYYY') + ' – ' + bis.format('DD.MM.YYYY');
  }
}
